var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ai-check-container" },
    [
      _c("div", { staticClass: "ai-header-banner" }, [
        _c("div", { staticClass: "banner-overlay" }),
        _c("div", { staticClass: "banner-content" }, [
          _vm._m(0),
          _c(
            "div",
            { staticClass: "banner-actions flex gap-2" },
            [
              _c(
                "el-dropdown",
                {
                  staticClass: "modern-dropdown-wrapper",
                  on: { command: _vm.handleCommand },
                },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "gradient-btn purple-btn",
                      attrs: { type: "warning" },
                    },
                    [
                      _vm._v("\n            Tác vụ gộp "),
                      _c("i", {
                        staticClass: "el-icon-arrow-down el-icon--right",
                      }),
                    ]
                  ),
                  _c(
                    "el-dropdown-menu",
                    {
                      staticClass: "modern-dropdown-menu",
                      attrs: { slot: "dropdown" },
                      slot: "dropdown",
                    },
                    [
                      _c(
                        "el-dropdown-item",
                        {
                          attrs: {
                            command: "enableOnlinePayment",
                            icon: "el-icon-circle-check",
                          },
                        },
                        [_vm._v("Bật thanh toán trực tuyến")]
                      ),
                      _c(
                        "el-dropdown-item",
                        {
                          attrs: {
                            command: "disableOnlinePayment",
                            icon: "el-icon-circle-close",
                          },
                        },
                        [_vm._v("Tắt thanh toán trực tuyến")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
      _c("div", { staticClass: "ai-stats-grid" }, [
        _c("div", { staticClass: "stat-card blue" }, [
          _vm._m(1),
          _c("div", { staticClass: "stat-info" }, [
            _c("p", { staticClass: "stat-label" }, [
              _vm._v("Tổng học sinh sử dụng"),
            ]),
            _c("h3", { staticClass: "stat-value" }, [
              _vm._v(_vm._s(_vm.numberStudentOnlinePayment)),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "stat-card green" }, [
          _vm._m(2),
          _c("div", { staticClass: "stat-info" }, [
            _c("p", { staticClass: "stat-label" }, [
              _vm._v("Hạn mức giới hạn (Trường)"),
            ]),
            _c("h3", { staticClass: "stat-value" }, [
              _vm._v(_vm._s(_vm.totalLimitConfigSchool)),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "stat-card purple" }, [
          _vm._m(3),
          _c("div", { staticClass: "stat-info" }, [
            _c("p", { staticClass: "stat-label" }, [_vm._v("Vượt hạn mức")]),
            _c("h3", { staticClass: "stat-value" }, [
              _vm._v(
                _vm._s(_vm.onlinePaymentLimit ? "Không cho phép" : "Cho phép")
              ),
            ]),
          ]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "glass-card mb-4" },
        [
          _c(
            "el-form",
            {
              staticClass: "modern-filter-form",
              attrs: { inline: true, model: _vm.dataSearch },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Trường học" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "modern-select school-select",
                      attrs: { filterable: "", placeholder: "Chọn trường" },
                      on: { change: _vm.handleChangeSchool },
                      model: {
                        value: _vm.dataSearch.idSchool,
                        callback: function ($$v) {
                          _vm.$set(_vm.dataSearch, "idSchool", $$v)
                        },
                        expression: "dataSearch.idSchool",
                      },
                    },
                    _vm._l(_vm.schoolList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: {
                          value: item.id,
                          label: `${item.id} - ${item.schoolName}`,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Trạng thái học sinh" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "modern-select",
                      attrs: { placeholder: "Trạng thái" },
                      on: { change: _vm.searchHeaderMethod },
                      model: {
                        value: _vm.dataSearch.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.dataSearch, "status", $$v)
                        },
                        expression: "dataSearch.status",
                      },
                    },
                    _vm._l(_vm.kidStatusList, function (item) {
                      return _c("el-option", {
                        key: item.key,
                        attrs: { value: item.key, label: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Khối học" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "modern-select",
                      attrs: { clearable: "", placeholder: "Tất cả khối" },
                      on: { change: _vm.changeGradeMethod },
                      model: {
                        value: _vm.dataSearch.idGrade,
                        callback: function ($$v) {
                          _vm.$set(_vm.dataSearch, "idGrade", $$v)
                        },
                        expression: "dataSearch.idGrade",
                      },
                    },
                    _vm._l(_vm.gradeOfSchoolList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { value: item.id, label: item.gradeName },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Lớp học" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "modern-select",
                      attrs: {
                        filterable: "",
                        clearable: "",
                        placeholder: "Tất cả lớp",
                      },
                      on: { change: _vm.searchHeaderMethod },
                      model: {
                        value: _vm.dataSearch.idClass,
                        callback: function ($$v) {
                          _vm.$set(_vm.dataSearch, "idClass", $$v)
                        },
                        expression: "dataSearch.idClass",
                      },
                    },
                    _vm._l(_vm.classList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { value: item.id, label: item.className },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Tìm kiếm nhanh" } },
                [
                  _c("el-input", {
                    staticClass: "modern-input",
                    attrs: {
                      clearable: "",
                      placeholder: "Tên, biệt danh, SĐT...",
                      "prefix-icon": "el-icon-search",
                    },
                    on: { clear: _vm.searchHeaderMethod },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.searchHeaderMethod.apply(null, arguments)
                      },
                    },
                    model: {
                      value: _vm.dataSearch.nameOrPhone,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataSearch, "nameOrPhone", $$v)
                      },
                      expression: "dataSearch.nameOrPhone",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticClass: "filter-actions" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: { click: _vm.searchHeaderMethod },
                    },
                    [_vm._v("Lọc dữ liệu")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "glass-card table-container mb-4" },
        [
          _c("div", { staticClass: "table-header-info" }, [
            _vm._m(4),
            _vm.multipleSelection.length > 0
              ? _c("span", { staticClass: "selection-count" }, [
                  _vm._v("Đang chọn: "),
                  _c("strong", [_vm._v(_vm._s(_vm.multipleSelection.length))]),
                  _vm._v(" học sinh"),
                ])
              : _vm._e(),
          ]),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingData,
                  expression: "loadingData",
                },
              ],
              ref: "multipleTable",
              staticClass: "modern-table",
              attrs: {
                data: _vm.studentList,
                "element-loading-text": "Đang tải danh sách học sinh...",
                "element-loading-spinner": "el-icon-loading",
                "element-loading-background": "rgba(255,255,255,0.7)",
                border: "",
                "highlight-current-row": "",
                "max-height": _vm.tableMaxHeight,
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "selection",
                  width: "55",
                  align: "center",
                  fixed: "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  label: "STT",
                  width: "55",
                  align: "center",
                  fixed: "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Mã Học Sinh",
                  width: "130",
                  align: "center",
                  prop: "kidCode",
                  fixed: "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("code", { staticClass: "code-badge" }, [
                          _vm._v(_vm._s(row.kidCode)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Họ và tên",
                  "min-width": "180",
                  prop: "fullName",
                  fixed: "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("span", { staticClass: "student-name" }, [
                          _vm._v(_vm._s(row.fullName)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Biệt danh",
                  "min-width": "120",
                  align: "center",
                  prop: "nickName",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("span", { staticClass: "nickname-text" }, [
                          _vm._v(_vm._s(row.nickName || "—")),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Lớp học",
                  "min-width": "130",
                  align: "center",
                  prop: "maClass.className",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("span", { staticClass: "class-text" }, [
                          _vm._v(
                            _vm._s(row.maClass ? row.maClass.className : "—")
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Giới tính",
                  width: "100",
                  align: "center",
                  prop: "gender",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: row.gender === "Nữ" ? "danger" : "primary",
                              size: "medium",
                              effect: "plain",
                            },
                          },
                          [_vm._v(_vm._s(row.gender))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Trạng thái thanh toán",
                  width: "220",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("el-switch", {
                          attrs: {
                            "active-color": "#10b981",
                            "inactive-color": "#cbd5e1",
                            disabled: _vm.checkLimitOnlinePayment,
                          },
                          on: {
                            change: function ($event) {
                              return _vm.handleEnableOnlinePayment(row)
                            },
                          },
                          model: {
                            value: row.enableOnlinePayment,
                            callback: function ($$v) {
                              _vm.$set(row, "enableOnlinePayment", $$v)
                            },
                            expression: "row.enableOnlinePayment",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-wrapper" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "current-page": _vm.pageNumber,
                  "page-sizes": _vm.$pageListDefaultUser || [10, 20, 50, 100],
                  "page-size": _vm.maxPageItem,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.pageTotal,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "glass-card" },
        [
          _c("div", { staticClass: "history-header" }, [
            _c("div", { staticClass: "history-title-group" }, [
              _c("h3", { staticClass: "history-main-title" }, [
                _vm._v("LỊCH SỬ THAY ĐỔI VƯỢT HẠN MỨC CHO PHÉP"),
              ]),
              _c("p", { staticClass: "history-subtitle" }, [
                _vm._v(
                  "\n          Tổng số học sinh sử dụng lớn nhất thay đổi trong tháng: \n          "
                ),
                _c("strong", { staticClass: "max-value" }, [
                  _vm._v(_vm._s(_vm.maxValueChange) + " học sinh"),
                ]),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "history-filter-right" },
              [
                _c("el-date-picker", {
                  staticClass: "month-picker",
                  attrs: {
                    clearable: false,
                    type: "month",
                    placeholder: "Chọn tháng",
                    "value-format": "M-yyyy",
                    format: "MM-yyyy",
                  },
                  on: { change: _vm.searchByPropertiesHistory },
                  model: {
                    value: _vm.month,
                    callback: function ($$v) {
                      _vm.month = $$v
                    },
                    expression: "month",
                  },
                }),
              ],
              1
            ),
          ]),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingDataHistory,
                  expression: "loadingDataHistory",
                },
              ],
              staticClass: "modern-table mt-3",
              attrs: {
                data: _vm.studentListChange,
                "element-loading-text": "Đang tải lịch sử hạn mức...",
                "element-loading-spinner": "el-icon-loading",
                "element-loading-background": "rgba(255,255,255,0.7)",
                border: "",
                "highlight-current-row": "",
                "max-height": 450,
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  label: "STT",
                  width: "60",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Thời gian ghi nhận thay đổi",
                  "min-width": "220",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("span", { staticClass: "date-time-text" }, [
                          _vm._v(_vm._s(_vm.formatDate(row.createdDate))),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Số học sinh thay đổi gần nhất",
                  "min-width": "220",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-button",
                          {
                            staticClass: "link-action-btn",
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handleClickShowStudents(
                                  row.id,
                                  "change"
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(row.numberStudentChange) +
                                " học sinh\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Tổng số học sinh đang sử dụng khi thay đổi",
                  "min-width": "260",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-button",
                          {
                            staticClass: "link-action-btn primary",
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handleClickShowStudents(
                                  row.id,
                                  "all"
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(row.sumNumberStudentChangeUser) +
                                " học sinh\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-wrapper mt-3" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "current-page": _vm.pageNumber2,
                  "page-sizes": _vm.$pageListDefaultUser || [10, 20, 50, 100],
                  "page-size": _vm.maxPageItem2,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.pageTotal2,
                },
                on: {
                  "size-change": _vm.handleSizeChange2,
                  "current-change": _vm.handleCurrentChange2,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("StudentChangeOnlinePaymentDialog", {
        attrs: {
          isStudentChangeOnlinePaymentDialog:
            _vm.isStudentChangeOnlinePaymentDialog,
          type: _vm.type,
          idHistory: _vm.idHistory,
          typeUser: _vm.typeUser,
          idSchool: _vm.idSchool,
        },
        on: { closeDialog: _vm.closeStudentChangeOnlinePaymentDialog },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "banner-left" }, [
      _c("div", { staticClass: "ai-icon-pulse" }, [
        _c("i", { staticClass: "el-icon-user-solid" }),
      ]),
      _c("div", [
        _c("h1", { staticClass: "banner-title" }, [
          _vm._v("DANH SÁCH HỌC SINH SỬ DỤNG THANH TOÁN"),
        ]),
        _c("p", { staticClass: "banner-subtitle" }, [
          _vm._v(
            "Quản lý và cấp quyền thanh toán trực tuyến cho học sinh, giám sát hạn mức cấu hình trường học."
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "stat-icon" }, [
      _c("i", { staticClass: "el-icon-s-custom" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "stat-icon" }, [
      _c("i", { staticClass: "el-icon-warning-outline" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "stat-icon" }, [
      _c("i", { staticClass: "el-icon-lock" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h4", { staticClass: "table-title" }, [
      _c("i", { staticClass: "el-icon-user" }),
      _vm._v(" DANH SÁCH HỌC SINH NHÀ TRƯỜNG"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }